// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file controls/v1/control_criteria.proto (package controls.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file controls/v1/control_criteria.proto.
 */
export const file_controls_v1_control_criteria: GenFile = /*@__PURE__*/
  fileDesc("CiJjb250cm9scy92MS9jb250cm9sX2NyaXRlcmlhLnByb3RvEgtjb250cm9scy52MSJ9Cg9Db250cm9sQ3JpdGVyaWESFgoJdmFsaWRhdGVkGAEgASgJSACIAQESEAoDZ2FwGAIgASgJSAGIAQESGQoMaW5zdWZmaWNpZW50GAMgASgJSAKIAQFCDAoKX3ZhbGlkYXRlZEIGCgRfZ2FwQg8KDV9pbnN1ZmZpY2llbnRCtQEKD2NvbS5jb250cm9scy52MUIUQ29udHJvbENyaXRlcmlhUHJvdG9QAVo/Z2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9jb250cm9scy92MTtjb250cm9sc3YxogIDQ1hYqgILQ29udHJvbHMuVjHKAgtDb250cm9sc1xWMeICF0NvbnRyb2xzXFYxXEdQQk1ldGFkYXRh6gIMQ29udHJvbHM6OlYxYgZwcm90bzM");

/**
 * @generated from message controls.v1.ControlCriteria
 */
export type ControlCriteria = Message<"controls.v1.ControlCriteria"> & {
  /**
   * @generated from field: optional string validated = 1;
   */
  validated?: string;

  /**
   * @generated from field: optional string gap = 2;
   */
  gap?: string;

  /**
   * @generated from field: optional string insufficient = 3;
   */
  insufficient?: string;
};

/**
 * Describes the message controls.v1.ControlCriteria.
 * Use `create(ControlCriteriaSchema)` to create a new message.
 */
export const ControlCriteriaSchema: GenMessage<ControlCriteria> = /*@__PURE__*/
  messageDesc(file_controls_v1_control_criteria, 0);

